import { RouteConfig } from "vue-router";
const BASE_PATH = "views/basicMangement";
const basicMangement: Array<RouteConfig> = [
  {
    path: "basic-info/basic-mangement",
    name: "basicMangement",
    redirect: { name: "materiallist" },
    meta: {
      menuMatch: "basicMangement",
    },
    component: () => import(`@/${BASE_PATH}/Main.vue`),
    children: [
      {
        path: "materiallist",
        name: "materiallist",
        component: () =>
          import(`@/${BASE_PATH}/materialmange/list/MaterialList.vue`),
        meta: {
          index: "3-1-1",
        },
      },
      {
        path: "inoutstock",
        name: "inoutstock",
        component: () =>
          import(`@/${BASE_PATH}/materialmange/stock/InoutStock.vue`),
        meta: {
          index: "3-1-2",
        },
      },
      {
        path: "stockcheck",
        name: "stockcheck",
        component: () =>
          import(`@/${BASE_PATH}/materialmange/check/StockCheck.vue`),
        meta: {
          index: "3-1-3",
        },
      },
      {
        path: "materiallist1",
        name: "materiallist1",
        component: () => import(`@/${BASE_PATH}/equipmange/list/EquipmentList.vue`),
        meta: {
          index: "3-2-1",
        },
      },
      {
        path: "inoutstock1",
        name: "inoutstock1",
        component: () => import(`@/${BASE_PATH}/materialmange/stock/InoutStock.vue`),
        meta: {
          index: "3-2-2",
        },
      },
      {
        path: "stockcheck1",
        name: "stockcheck1",
        component: () => import(`@/${BASE_PATH}/equipmange/check/StockCheck.vue`),
        meta: {
          index: "3-2-3",
        },
      },
      {
        path: "filemange",
        name: "filemange",
        component: () => import(`@/${BASE_PATH}/file/FileMange.vue`),
        meta: {
          index: "3-3",
        },
      },
      {
        path: "sciencemange",
        name: "sciencemange",
        component: () => import(`@/${BASE_PATH}/scienceMange/Sciencemange.vue`),
        meta: {
          index: "3-4",
        },
      },
      {
        path: "ScienceDetail",
        name: "ScienceDetail",
        component: () => import(`@/${BASE_PATH}/scienceMange/ScienceDetail.vue`),
        meta: {
          index: "3-4",
        },
      },
      {
        path: "trainmange",
        name: "trainmange",
        component: () => import(`@/${BASE_PATH}/train/Trainmange.vue`),
        meta: {
          index: "3-5",
        },
      },
    ],
  },
];
export default basicMangement;
